<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="heading">Heading</label>
                    <input id="heading" type="text" class="form-control" [(ngModel)]="target.heading" name="heading" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="content">Content</label>
                    <quill-editor
                        #quillEditorRef
                        style="width: 100%"
                        [(ngModel)]="target.content"
                        name="content"
                        [styles]="{ height: '200px' }"
                        [modules]="editorModules"
                    >
                    </quill-editor>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
